export const MAX_CME_POINTS_VALUE = 250
export const KALTURA_TOKEN = "kalturaToken"
export const REACT_APP_STRIPE_PK = process.env.REACT_APP_STRIPE_PK
export const REACT_APP_KALTURA_PARTNER_ID = process.env.REACT_APP_KALTURA_PARTNER_ID
export const REACT_APP_KALTURA_UI_CONFIG_ID = process.env.REACT_APP_KALTURA_UI_CONFIG_ID
